import { Component } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';

import { BaseFieldComponent } from '../base-field/base-field.component';
import { CheckboxControlComponent } from '../../../controls/standard/checkbox-control/checkbox-control.component';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-checkbox-field',
	standalone: true,
	imports: [AngularModule, CheckboxControlComponent],
	templateUrl: './checkbox-field.component.html',
	styleUrls: ['./checkbox-field.component.scss'],
})
export class CheckboxFieldComponent extends BaseFieldComponent {
	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 12:02:22 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [Validators.required];
}
